import { SWRConfiguration } from 'swr';

import { useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export type PersonProfile = {
  id: number;
  firstName: string;
  lastName: string;
  givenNames: string;
  gender: string;
  dateOfBirth: string;
  ssn: string;
  nationalityFK: string;
  employeeNumber: string;
  pictureId: string;
  socialProfile: string;
  empPresentation: string;
  createdTime: string;
  updatedTime: string;
};

export const updatePersonProfile = async (
  profileId: number,
  data: PersonProfile,
) => {
  const api = `/json/persons/${profileId}/profile`;
  return fetchFromOldApi(api, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then((r) => r.json());
};

export const getPersonProfile = async (
  profileId: number,
): Promise<PersonProfile> => {
  return fetchFromOldApi(`/json/persons/${profileId}/profile`).then((r) =>
    r.json(),
  );
};

type PropsType = {
  profileId?: number;
};
export const usePersonProfile = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { profileId } = props;

  return useSWR<PersonProfile>(
    !!profileId && !isDisabled ? ['getEmployeeProfile', profileId] : null,
    ([_key, profileId]: [string, number]) => getPersonProfile(profileId),
    swrConfig,
  );
};
